import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientIntegrationsAthena = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientIntegrationsAthena',
    (integration) => integration.patientId === patientId,
  ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
